import React, { Fragment, useState } from "react";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import InstagramSection from "../../components/InstagramSection/InstagramSection";
import Logo from "../../images/logo.svg";
import "./ImpactPage.css";
import Cimg1 from '../../images/impact/1.webp'
import Cimg2 from '../../images/impact/2.webp'
import Cimg3 from '../../images/impact/3.webp'
import Cimg4 from '../../images/impact/4.webp'
import Cimg5 from '../../images/impact/5.webp'
import Cimg6 from '../../images/impact/6.webp'
import Cimg7 from '../../images/impact/7.webp'
import Cimg8 from '../../images/impact/8.webp'
import Cimg9 from '../../images/impact/9.webp'
import { TikTokEmbed } from "react-social-media-embed";
import GallerySection from "../../components/GallerySection/Gallerysection";




const videos = [
  {
    name: "Milion",
    age: 3,
    city: "Addis Ababa",
    img: Cimg1,
    vid: "videos/impact 1.mp4",
    desc: "After waiting 3 years for heart surgery, Milion is now back to school and full of life."
  },
  {
    name: "Ferhan",
    age: 5,
    city: "Hawassa",
    img: Cimg2,
    vid: "videos/impact-2.mp4",
    desc: "Recovered after a successful operation and now enjoying school activities."
  },
  {
    name: "Pinel",
    age: 3,
    city: "Harar",
    img: Cimg4,
    vid: "videos/impact-3.mp4",
    desc: "A joyful recovery and a bright future aheadis now back to school and full of life.."
  }
];
const stories = [
  {
    name: "Bemnet",
    age: 7,
    city: "Addis Ababa",
    img: Cimg1,
    vid: "FEATURED_VIDEO_1.mp4",
    desc: "Aa 7-year-old with Down syndrome. After receiving the life-changing surgery he needed, his health and energy improved. Today, Bemnet is thriving — more active, focused, and able to fully enjoy learning and play."
  },
  {
    name: "Yididiya",
    age: 4,
    city: "Adama",
    img: Cimg3,
    vid: "FEATURED_VIDEO_3.mp4",
    desc: "A joyful 4-year-old with Down syndrome and PDA, once struggled with challenges that limited her daily life.  She received the critical treatment she needed. Today, Yididiya is healthier, happier, and growing stronger every single day."
  },
  {
    name: "Genet",
    age: 6,
    city: "Mekelle",
    img: Cimg4,
    vid: "FEATURED_VIDEO_4.mp4",
    desc: "A spirited 6-year-old, was born with a large heart opening that made everyday activities challenging. After receiving the critical surgery her heart needed, she began to regain her strength. Today, Genet is healthier and enjoying life to the fullest."
  },
  {
    name: "Rahmet",
    age: 13,
    city: "Hawassa",
    img: Cimg6,
    vid: "FEATURED_VIDEO_2.mp4",
    desc: "Rahment was living with a complex congenital heart defect that left two abnormal openings in her heart.  After undergoing a major corrective surgery, her heart finally began to heal."
  },
];

const tiktoks = [
  {
    vid: "https://www.tiktok.com/@heart_to_heart_aid/video/7618278705055419668",
  },
  {
    vid: "https://www.tiktok.com/@heart_to_heart_aid/video/7617550119180700948",
  },
   {
    vid: "https://www.tiktok.com/@heart_to_heart_aid/video/7618280996558966036"
  },
  {
    vid: "https://www.tiktok.com/@heart_to_heart_aid/video/7616769785757453588"
  },
  {
    vid: "https://www.tiktok.com/@heart_to_heart_aid/video/7617076128263474453"
  },
  {
    vid: "https://www.tiktok.com/@heart_to_heart_aid/video/7617098350159990036"
  },
   {
    vid: "https://www.tiktok.com/@heart_to_heart_aid/video/7617524487235423508"
  },
 
   {
    vid: "https://www.tiktok.com/@heart_to_heart_aid/video/7615666840982867220"
  },
  {
    vid: "https://www.tiktok.com/@heart_to_heart_aid/video/7615691890360372500"
  },
  {
    vid: "https://www.tiktok.com/@heart_to_heart_aid/video/7615976669458861332"
  },
   {
    vid: "https://www.tiktok.com/@heart_to_heart_aid/video/7616039657100381461"
  },
  {
    vid: "https://www.tiktok.com/@heart_to_heart_aid/video/7616395838817914132"
  },
   
];
const ImpactPage = () => {
  const [visibleCount, setVisibleCount] = useState(3);

  const loadMore = () => {
    setVisibleCount((v) => Math.min(v + 3, stories.length));
  };

  return (
    <Fragment>
      <Navbar Logo={Logo} hclass={"wpo-site-header-s5"} />

      {/* ====================================================== */}
      {/* HERO SECTION */}
      {/* ====================================================== */}
      <section className="impact-hero">


        <div className="impact-video-wrapper">
          <video
            autoPlay
            loop
            muted>
            <source src="videos/video1.mp4" type="video/mp4" />
          </video>
        </div>
         <div className="container text-center">
          <h2 className="impact-title">Every Heartbeat Matters</h2>
          <p className="lead ">
           At Heart-to-Heart Children Aid, this belief drives our mission: Every child deserves a 
chance to grow up healthy. That is why we provide free, life-saving heart surgeries to 
children whose families cannot afford essential care.
          </p>
        </div>
      </section>

      {/* ====================================================== */}
      {/* STORIES OF HOPE */}
      {/* ====================================================== */}
      <section className="section-padding stories-section">
        <div className="container">
          <h2 className="section-heading text-center impact-subtitle">
            Stories of Hope
          </h2>
          <p className="section-desc text-center impact-section-title">
            Real children. Real stories. Real second chances.
          </p>

          <div className="row mt-4">
            {videos.map((child, idx) => (
              <div className="col-lg-4 col-md-6 col-12 mb-4" key={idx}>
                <div className="impact-card shadow-sm">
                  <video
                    controls
                    loop
                    muted
                    className="impact-thumb"
                    src={child.vid}
                    alt={child.name}
                  />
                  <div className="impact-info">
                    <h4>{child.name}, Age {child.age}</h4>
                    <span className="text-muted">{child.city}</span>
                    <p className="mt-2">{child.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ====================================================== */}
      {/* INSTAGRAM FULL WIDTH */}
      {/* ====================================================== */}
      <div className="instagram-full-viewport">
        <InstagramSection />
      </div>

      {/* ====================================================== */}
      {/* CALL TO ACTION */}
      {/* ====================================================== */}
      <section className="section-padding cta-section text-center">
        <div className="container">
           {/* Second row - TikTok videos in your custom styled cards */}
          {/* <div className="row mt-4">
            {tiktoks.map((child, idx) => (
              <div className="col-lg-4 col-md-6 col-12 mb-4" key={idx}>
                <div className="img-fram video">
                  <div className="tiktok-fit-container">
                    <TikTokEmbed 
                      url={child.vid} 
                      width={348} 
                      height={560}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div> */}

                      <GallerySection />
          
             <div className="row mt-4 p-3">
            {stories.slice(0, visibleCount).map((child, idx) => (
              <div className="col-lg-4 col-md-6 col-12 mb-4" key={idx}>
                <div className="impact-card shadow-sm">
                  <img
                    src={child.img}
                    alt={child.name}
                    className="impact-thumb"
                  />
                  <div className="impact-info" style={{lineHeight:'1.5', textAlign:'justify'}}>
                    <h4>{child.name}, Age {child.age}</h4>
                    {/* <span className="text-muted">{child.city}</span> */}
                    <p className="mt-2 mx-2"  style={{fontSize:'16px',lineHeight:'1.5',}}>{child.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="text-center mt-4">
            {visibleCount < stories.length && (
              <button className="theme-btn" onClick={loadMore}>Load More Stories</button>
            )}
          </div>

           

          {/* <h2>You Can Save the Next Child</h2>
          <p className="lead mb-4" style={{ maxWidth: "700px", margin: "0 auto" }}>
            Over 30 children have received life-saving heart surgeries — but
            thousands more are still waiting.  
            Your help can change a child's entire future.
          </p>

          <div className="cta-buttons">
            <button className="theme-btn">Donate Now</button>
            <button className="theme-btn">Sponsor a Child</button>
            <button className="theme-btn">Partner With Us</button>
          </div> */}
        </div>
      </section>

      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default ImpactPage;
